import React from "react";
import ReactHtmlParser from "react-html-parser";
import { IRestrictedView } from "./IRestrictedView";
import { RestrictedContainer } from "@appComponents/RestrictedContainer/RestrictedContainer";
import {
  withdrawValidationMessages,
  depositValidationMessages,
  buyValidationMessages,
  sellValidationMessages,
  tradeAnyRestrictionMessage,
} from "@funds/features/helpers/validationMessages";
import { EActionTypes } from "../ActionsList/IActionsList";
import {
  depositAbilities,
  withdrawAbilities,
  buyAbilities,
  sellAbilities,
} from "@market/interfaces/IWallet";
import { restrictedByUserStatementKey } from "@funds/features/helpers/validation";

import * as styles from "./RestrictedViewStyles.module.scss";

export const RestrictedView = (props: IRestrictedView) => {
  const renderMessage = (): string => {
    const {
      wallet,
      action,
      isUsInvestor,
      abilityKey,
      verificationUrl,
      securityUrl,
    } = props;

    const getAbilities = () => {
      if (action === EActionTypes.buy) {
        return wallet?.abilities.can_buy === true
          ? []
          : (wallet?.abilities.can_buy as string[]);
      } else if (action === EActionTypes.sell) {
        return wallet?.abilities.can_sell === true
          ? []
          : (wallet?.abilities.can_sell as string[]);
      }

      return [];
    };

    const hasMultipleRestrictions =
      (getAbilities()?.length ?? 0) > 1 &&
      getAbilities()?.includes(restrictedByUserStatementKey);

    switch (action) {
      case EActionTypes.buy:
        if (!wallet) throw new Error("Wallet not found");
        return hasMultipleRestrictions
          ? tradeAnyRestrictionMessage
          : buyValidationMessages(wallet, undefined, isUsInvestor)[
              abilityKey as buyAbilities
            ];
      case EActionTypes.deposit:
        return depositValidationMessages(undefined, isUsInvestor, wallet)[
          abilityKey as depositAbilities
        ];
      case EActionTypes.sell:
        if (!wallet) throw new Error("Wallet not found");
        return hasMultipleRestrictions
          ? tradeAnyRestrictionMessage
          : sellValidationMessages(wallet, undefined, isUsInvestor)[
              abilityKey as sellAbilities
            ];
      case EActionTypes.withdraw: {
        return withdrawValidationMessages(verificationUrl, securityUrl)[
          abilityKey as withdrawAbilities
        ];
      }
    }
  };

  return (
    <RestrictedContainer center={true}>
      <div className={styles.message}>{ReactHtmlParser(renderMessage())}</div>
    </RestrictedContainer>
  );
};
